import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { DeviceStatus } from '../../enums/deviceStatus';
import { Device } from '../../interfaces';
import { theme } from '../../theme';
import { Dot } from './dot';

interface Props {
  device: Device;
}

export function ProvisioningStatus(props: Props) {
  let color = 'gray';
  const { status } = props.device;

  switch (status) {
    case DeviceStatus.provisionedStr:
      color = theme.green;
      break;
    case DeviceStatus.provisioningErrorStr:
      color = theme.red;
      break;

    case DeviceStatus.provisioningInitiatedStr:
      color = theme.orange;
      break;

    case DeviceStatus.registeredStr:
      color = theme.lightGreen;
  }

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{status}</Tooltip>}>
      <Dot color={color} data-provisioning-status={status} />
    </OverlayTrigger>
  );
}
